/**
 * Date dropdown: Flowbite datepickers, open panel, scroll to subsections.
 * Deep links: #filter-dates, #filter-date-created, #filter-last-public-reply, #filter-last-internal-reply, #filter-deadline
 */

import Datepicker from 'flowbite/lib/esm/components/datepicker/index.js';

const OVERVIEW_DATE_INPUT = '[data-overview-date]';
const MORE_PANEL_ID = 'flt-more-dd';
const MORE_BTN_ID = 'flt-more-btn';
const TARGET_ATTR = 'data-more-filters-target';

const KNOWN_HASH_IDS = new Set([
    'filter-dates',
    'filter-date-created',
    'filter-last-public-reply',
    'filter-last-internal-reply',
    'filter-deadline',
]);

function openMoreFiltersIfClosed(): void {
    const panel = document.getElementById(MORE_PANEL_ID);
    const btn = document.getElementById(MORE_BTN_ID);
    if (!panel || !btn) {
        return;
    }
    if (panel.classList.contains('hidden')) {
        btn.click();
    }
}

function scrollToTarget(targetId: string): void {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            let el = document.getElementById(targetId);
            if (!el && targetId !== 'filter-dates') {
                el = document.getElementById('filter-dates');
            }
            el?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            const dateInput = el?.querySelector(OVERVIEW_DATE_INPUT) as HTMLInputElement | null;
            if (dateInput) {
                dateInput.focus({ preventScroll: true });
            }
        });
    });
}

function jumpToMoreFiltersTarget(targetId: string): void {
    openMoreFiltersIfClosed();
    scrollToTarget(targetId);
}

function initTicketOverviewDatepickers(): void {
    const page = document.querySelector('[data-ticket-overview-page]');
    if (!page) {
        return;
    }
    page.querySelectorAll<HTMLInputElement>(OVERVIEW_DATE_INPUT).forEach((input) => {
        const orientation = input.name.endsWith('_to') ? 'bottom right' : 'bottom';
        new Datepicker(input, {
            autohide: true,
            format: 'yyyy-mm-dd',
            orientation,
        });
    });
}

export function initTicketOverviewMoreFiltersJump(): void {
    initTicketOverviewDatepickers();

    document.addEventListener('click', (e: MouseEvent) => {
        const trigger = (e.target as Element | null)?.closest(`[${TARGET_ATTR}]`);
        if (!trigger) {
            return;
        }
        const targetId = trigger.getAttribute(TARGET_ATTR);
        if (!targetId) {
            return;
        }
        e.preventDefault();
        jumpToMoreFiltersTarget(targetId);
    });

    const raw = location.hash.replace(/^#/, '');
    const hash = raw ? decodeURIComponent(raw) : '';
    if (hash && KNOWN_HASH_IDS.has(hash)) {
        jumpToMoreFiltersTarget(hash);
    }
}
